import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  class: "modal-dialog modal-dialog-centered modal-lg",
  role: "document"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header bg-white border-bottom" }
const _hoisted_4 = { class: "modal-body p-4" }
const _hoisted_5 = { class: "row g-3" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = {
  key: 1,
  class: "form-control bg-light text-muted"
}
const _hoisted_12 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = { class: "modal-footer" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_vue_tel_input = _resolveComponent("vue-tel-input")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-backdrop fade show",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
        }))
      : _createCommentVNode("", true),
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "modal fade show d-block",
          tabindex: "-1",
          role: "dialog",
          style: {"z-index":"1055"},
          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "modal-title fw-bold text-dark" }, " Ajouter un nouvel acteur ", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "aria-label": "Fermer",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
                })
              ]),
              _createVNode(_component_Form, {
                onSubmit: _ctx.onSubmit,
                "validation-schema": _ctx.acteurSchema,
                "initial-values": _ctx.localForm
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
                          _createTextVNode(" Nom complet "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "nomComplet",
                          type: "text",
                          class: "form-control",
                          placeholder: "Nom complet"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "nomComplet",
                          class: "text-danger d-block mt-1"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
                          _createTextVNode(" Email "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "email",
                          type: "email",
                          class: "form-control",
                          placeholder: "exemple@email.com"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "email",
                          class: "text-danger d-block mt-1"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                            _createTextVNode(" Pays "),
                            _createElementVNode("span", { class: "text-danger" }, "*")
                          ], -1)),
                          _createVNode(_component_Field, { name: "pays" }, {
                            default: _withCtx(({ field }) => [
                              _createVNode(_component_Multiselect, _mergeProps({
                                options: _ctx.paysOptions,
                                searchable: true,
                                "track-by": "label",
                                label: "label",
                                modelValue: field.value,
                                "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                              }, field, {
                                placeholder: "Sélectionner le pays",
                                onChange: _ctx.onPaysChange
                              }), null, 16, ["options", "modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_component_ErrorMessage, {
                          name: "pays",
                          class: "text-danger"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
                          _createTextVNode(" Téléphone "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, { name: "telephone" }, {
                          default: _withCtx(({ field }) => [
                            (_ctx.selectedCountryCode)
                              ? (_openBlock(), _createBlock(_component_vue_tel_input, _mergeProps({
                                  key: _ctx.selectedCountryCode,
                                  placeholder: "Entrer le numéro de téléphone",
                                  modelValue: field.value,
                                  "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                                }, field, {
                                  "default-country": _ctx.selectedCountryCode,
                                  mode: "international",
                                  onValidate: _ctx.validate,
                                  class: "shadow-none fs-md-15 text-black py-2"
                                }), null, 16, ["modelValue", "onUpdate:modelValue", "default-country", "onValidate"]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_11, " Veuillez d'abord sélectionner un pays "))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "telephone",
                          class: "text-danger"
                        }),
                        (_ctx.telephone && !_ctx.validPhone)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Veuillez entrer un numéro correct "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
                          _createTextVNode(" IFU "),
                          _createElementVNode("small", { class: "text-muted" }, "(optionnel)")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "ifu",
                          type: "text",
                          class: "form-control",
                          placeholder: "Numéro IFU"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
                          _createTextVNode(" RCCM "),
                          _createElementVNode("small", { class: "text-muted" }, "(optionnel)")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "rccm",
                          type: "text",
                          class: "form-control",
                          placeholder: "Numéro RCCM"
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-secondary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
                    }, " Annuler "),
                    _createElementVNode("button", {
                      type: "submit",
                      class: "btn btn-primary",
                      disabled: _ctx.saving || (_ctx.telephone && !_ctx.validPhone)
                    }, [
                      (_ctx.saving)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Enregistrement..."))
                        : (_openBlock(), _createElementBlock("span", _hoisted_18, "Enregistrer"))
                    ], 8, _hoisted_16)
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema", "initial-values"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}